<template lang="pug">
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
export default {
    data() {
        var that = this;

        return {
            tableName: 'ATTENDANCE_SUMMARY',
            columns: ['name', 'average', 'days', 'duration', 'export'],
            options: {
                columnsClasses: {
                    export: 'text-right',
                },
                sortable: ['name', 'average', 'days', 'duration'],
                useReportFilter: true,
                texts: {
                    title: 'Staff Attendance Summary',
                    description: 'Staff attendance summary details',
                },
                pdf_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'XLSX' },
                ),
                templates: {
                    export(h, row) {
                        return require('./export-staff-summary.jsx')(
                            h,
                            row,
                            this,
                        );
                    },
                },
                headings: {
                    export: '',
                },
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route(
                'franchise.report.staff_attendance.attendance_summary',
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/staff-attendance/staff-attendance-summary.vue